<form [formGroup]="dateFilters" class="summary-charts__form">
    <div class="summary-charts__container">
        <div class="summary-charts__row row">
            <div class="summary-charts__column">
                @let categories = options().categories;
                <div class="summary-charts__btn-group">
                    @if (categories?.today) {
                    <button class="summary-charts__btn" [class.active]="catSelected === 0"
                        (click)="catSelected = 0; updateDateFilters()">Today</button>
                    }
                    @if (categories?.yesterday) {
                    <button class="summary-charts__btn" [class.active]="catSelected === 1"
                        (click)="catSelected = 1; updateDateFilters()">Yesterday</button>
                    }
                    @if (categories?.week) {
                    <button class="summary-charts__btn" [class.active]="catSelected === 2"
                        (click)="catSelected = 2; updateDateFilters()">Week</button>
                    }
                    @if (categories?.month) {
                    <button class="summary-charts__btn" [class.active]="catSelected === 3"
                        (click)="catSelected = 3; updateDateFilters()">Month</button>
                    }
                    @if (categories?.custom) {
                    <button class="summary-charts__btn" [class.active]="catSelected === 4"
                        (click)="catSelected = 4">Custom</button>
                    }
                </div>
                <button class="summary-charts__btn summary-charts__btn--nav" (click)="previousPeriod()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                    </svg>
                </button>

                <input type="datetime-local" formControlName="startDate" class="summary-charts__input"
                    [readonly]="catSelected !== 4" />

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M22 12l-9-9v6H5v6h8v6z"></path>
                </svg>

                <input type="datetime-local" formControlName="endDate" class="summary-charts__input"
                    [readonly]="catSelected !== 4" />

                <button class="summary-charts__btn summary-charts__btn--nav" (click)="nextPeriod()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</form>
